import React from 'react';
import { createRoot } from 'react-dom/client';
import Icons from '../components/Icons';

export function confirmAlert({ title = 'Are you sure?', message, confirmText = 'Delete', isDanger = true }) {
  return new Promise((resolve) => {
    const container = document.createElement('div');
    document.body.appendChild(container);
    
    const root = createRoot(container);

    const cleanup = () => {
      setTimeout(() => {
        root.unmount();
        if (container.parentNode) {
          container.parentNode.removeChild(container);
        }
      }, 0);
    };

    const handleConfirm = () => {
      resolve(true);
      cleanup();
    };

    const handleCancel = () => {
      resolve(false);
      cleanup();
    };

    const ModalContent = () => (
      <div className="mp-overlay" onClick={handleCancel} style={{ zIndex: 99999 }}>
        <div className="logout-confirm" onClick={e => e.stopPropagation()} style={isDanger ? { borderColor: 'rgba(239,68,68,0.25)', maxWidth: 380 } : { maxWidth: 380 }}>
          <div className="logout-icon" style={{ fontSize: 44, marginBottom: 8, textAlign: 'center' }}>
            {isDanger ? '⚠️' : '🗑️'}
          </div>
          <div className="logout-title" style={{ color: isDanger ? '#f87171' : 'var(--t1)', marginBottom: 8 }}>{title}</div>
          <div className="logout-desc" style={{ marginBottom: 22, lineHeight: 1.6, textAlign: 'center' }}>{message}</div>
          <div className="logout-btns">
            <button className="logout-btn cancel" onClick={handleCancel}>
              Cancel
            </button>
            <button 
              className="logout-btn confirm" 
              onClick={handleConfirm}
              style={isDanger ? { background: '#ef4444', borderColor: '#ef4444', color: '#fff' } : {}}
            >
              {isDanger ? <Icons.Trash sz={13} /> : null} {confirmText}
            </button>
          </div>
        </div>
      </div>
    );

    root.render(<ModalContent />);
  });
}
